import PhoneCall from 'models/phone_call';

export default class AddParticipantToPhoneCall {
  constructor(context) {
    this.context = context;
  }

  run({ participantId, type }) {
    const activeCall = this.context.stores.activeCall.get();
    if (activeCall) {
      activeCall.conversationItem.content.addParticipant({
        participantId,
        status: PhoneCall.ParticipantStatus.DIALING,
        statusUpdatedAt: new Date().toISOString(),
        type,
      });
      this.context.stores.activeCall.setPending(activeCall);

      this.context.gateways.phoneControlsHttp.addParticipant(activeCall.customer.id, activeCall.conversationItem.id, {
        participantId,
        type,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/phone_call/add_participant_to_phone_call.js